import React from 'react';
import { findIndex } from 'lodash';
import { LoginLayout } from '@skunexus/component-catalog';
import NikeLoginPage from './routes/NikeLoginPage';
import OktaFailedPage from './routes/OktaFailedPage';
import { SKUNEXUS_LOGIN_PATH, SKUNEXUS_FORGET_PASSWORD_CODE, OKTA_FAILED_PATH } from './constants';
import createConfigurableObject from '../../../utils/configurationObject';
import { isOktaEnalbed } from './utils';

function Layout({ children }) {
    return <LoginLayout>{children}</LoginLayout>;
}

const customAuthRoutes = (routes) => {
    if (!isOktaEnalbed()) {
        return routes;
    }

    const loginIndex = findIndex(routes, ['name', 'login']);

    if (loginIndex >= 0) {
        routes[loginIndex].path = SKUNEXUS_LOGIN_PATH;

        // eslint-disable-next-line prefer-destructuring
        const props = routes[loginIndex].props;

        routes[loginIndex].props = () => ({
            ...props(),
            forgetPasswordRoute: null,
        });
    }

    return [
        ...routes.filter(({ name }) => name !== SKUNEXUS_FORGET_PASSWORD_CODE),
        {
            name: 'nike-login',
            path: '/login',
            component: NikeLoginPage,
            layout: Layout,
            title: 'Okta Login',
            props: () => ({}),
        },
        {
            name: 'okta-failed',
            path: OKTA_FAILED_PATH,
            component: OktaFailedPage,
            layout: Layout,
            title: 'Okta Login Failure',
            props: () => ({}),
        },
    ];
};

export default {
    name: 'oktaLogin',
    before: [],
    after: [],
    setup: (app) => {
        app.general = app.general || createConfigurableObject();
        app.general.addMany({
            customAuthRoutes,
        });
    },
};
